/* GET2PACK · Gift banner (+1 bolsa de regalo) · v2
   - Banner section/bloğun konduğu yerde durur (taşıma yok → CLS yok).
   - Hediye kuralı: seçili Moon teklifinin indirimli fiyatı data-min-price ve üstüyse açık, değilse kilitli.
   - Kilitliyken banner'a dokunmak eşiği geçen teklifi seçer (data-pick: max = en pahalı, min = en ucuz).
   - Sayaç: visitor = ziyaretçi başına 3 saat, yenilemede sıfırlanmaz, bitince hemen yeniden başlar
            fixed  = sabit tarihe kadar, bitince gizlenir · global = herkese aynı dilim, bitince yeniden başlar
   - Performans: sayaç hemen başlar (layout okumaz); fiyat okuma + Moon izleme sayfa yüklenip tarayıcı boşalınca başlar
     (yükleme sırasında zorunlu layout yok → TBT'ye eklemez). Moon bulununca yalnız o izlenir; DOM yalnız değişen rakamda yazılır. */
(function () {
  var OPT_ACTIVE = '.moonbundle-option-active';
  var OPT_WRAP = '.moonbundle-option-wrapper';
  var MOON_BOX = '.moonbundle-box';
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
  var visible = function (e) { return !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)); };

  /* ── Fiyat: Moon'un fiyat alanı → üstü çizili olmayan ilk fiyat → metindeki en düşük fiyat ── */
  var PRICE = /(?:^|[^\d.,])(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d{1,2}))?\s*€|€\s*(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d{1,2}))?/g; // binlik ayırıcı yalnız nokta (es-ES)
  function parsePrices(txt) {
    var m, out = []; PRICE.lastIndex = 0;
    while ((m = PRICE.exec(txt))) {
      var int = (m[1] || m[3] || '').replace(/\./g, ''), dec = m[2] || m[4] || '0';
      if (int) out.push(parseFloat(int + '.' + dec));
    }
    return out;
  }
  function priceOf(el) {
    var own = el.querySelector('.moonbundle-option-single-price');
    if (own) { var v = parsePrices(own.textContent); if (v.length) return v[0]; }
    var leaves = el.querySelectorAll('*');
    for (var i = 0; i < leaves.length; i++) {
      var e = leaves[i];
      if (e.childElementCount || e.textContent.indexOf('€') < 0 || e.closest('s,del,strike')) continue;
      if (/line-through/.test(getComputedStyle(e).textDecorationLine)) continue;
      var p = parsePrices(e.textContent); if (p.length) return p[0];
    }
    var all = parsePrices(el.innerText || el.textContent || '');
    return all.length ? Math.min.apply(null, all) : null;
  }
  function currentPrice() {
    var act = Array.prototype.filter.call(document.querySelectorAll(OPT_ACTIVE), visible)[0] || document.querySelector(OPT_ACTIVE);
    var w = act && (act.closest(OPT_WRAP) || act);
    return w ? priceOf(w) : null;
  }
  function selectOffer(min, pick) {
    var best = null, bp = pick === 'min' ? Infinity : -Infinity;
    Array.prototype.forEach.call(document.querySelectorAll(OPT_WRAP), function (w) {
      if (!visible(w)) return;
      var p = priceOf(w); if (p === null || p < min) return;
      if (pick === 'min' ? p < bp : p > bp) { bp = p; best = w; }
    });
    if (!best) return false;
    (best.querySelector('.moonbundle-option') || best).click(); return true;
  }

  /* ── Sayaç deposu: localStorage → çerez → bellek ── */
  var mem = {};
  function store(key, val) {
    var got = null;
    try { if (val === undefined) got = localStorage.getItem(key); else localStorage.setItem(key, val); } catch (e) {}
    try {
      if (val === undefined) { if (got === null) { var m = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)')); got = m ? m[1] : null; } }
      else document.cookie = key + '=' + val + '; path=/; max-age=' + 60 * 60 * 24 * 30 + '; SameSite=Lax';
    } catch (e) {}
    if (val === undefined) return got !== null ? got : (mem[key] || null);
    mem[key] = val;
  }
  function deadline(el, force) { // force: süre şimdi bitti → yeni dilim
    var mode = el.dataset.mode || 'visitor', now = Date.now() + (force ? 1000 : 0);
    var dur = (parseFloat(el.dataset.hours) || 3) * 3600e3;
    if (mode === 'fixed') { var t = Date.parse(el.dataset.end); return isNaN(t) ? null : t; }
    if (mode === 'global') return now + (dur - now % dur);
    var key = 'g2pb_end_' + (el.dataset.campaignKey || 'default');
    var end = parseInt(store(key), 10);
    if (force || !end || end <= now || end > now + dur + 60e3) { end = now + dur; store(key, String(end)); } // bitti / yok / saat oynanmış
    return end;
  }

  // Yükleme bitince ve tarayıcı boşken çalıştır (layout o anda temiz → offsetWidth/getComputedStyle ucuz)
  function whenIdle(fn) {
    var go = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 1); })(fn, { timeout: 1500 }); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }

  function init(el) {
    if (el.__g2pb) return; el.__g2pb = true;
    var box = el.closest('.g2pb-block') || el;
    var min = parseFloat(el.dataset.minPrice); if (isNaN(min)) min = 70;
    var pick = el.dataset.pick === 'min' ? 'min' : 'max';
    var fallback = el.dataset.fallback === 'locked' ? 'locked' : 'unlocked';
    var live = el.querySelector('[data-g2pb-live]');
    var digits = [el.querySelector('[data-t="h"]'), el.querySelector('[data-t="m"]'), el.querySelector('[data-t="s"]')];
    var shown = ['', '', ''];
    var end = deadline(el), state = null, last = null, timer = null;

    function setState(next) {
      if (next === state) return;
      var prev = state; state = next; el.dataset.state = next;
      if (live && prev) live.textContent = next === 'unlocked' ? (el.dataset.liveOn || '') : (el.dataset.liveOff || '');
    }
    function sync() {
      var p = currentPrice();
      if (p === null) { setState(last || fallback); return; }
      last = p >= min ? 'unlocked' : 'locked'; setState(last);
    }
    function paint(left) {
      var v = [pad(Math.floor(left / 3600)), pad(Math.floor(left % 3600 / 60)), pad(left % 60)];
      for (var i = 0; i < 3; i++) if (v[i] !== shown[i]) { digits[i].textContent = v[i]; shown[i] = v[i]; }
    }
    function tick() {
      if (end === null) { box.hidden = true; return stop(); }
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left === 0) {
        if (el.dataset.mode === 'fixed') { box.hidden = true; return stop(); }
        end = deadline(el, true); left = Math.floor((end - Date.now()) / 1000); // döngü: 00:00:00 → 03:00:00
      }
      paint(left);
    }
    function start() { if (!timer) { tick(); timer = setInterval(tick, 1000); } }
    function stop() { clearInterval(timer); timer = null; }

    el.addEventListener('click', function () {
      if (el.dataset.state !== 'locked') return;
      if (!selectOffer(min, pick)) { last = 'unlocked'; setState('unlocked'); }
      setTimeout(sync, 60);
    });

    start();
    whenIdle(function () { sync(); watch(); });

    // Moon (Svelte) sınıf değiştirir. Önce yalnız Moon kutusu izlenir; henüz yoksa gelene kadar sayfa (yalnız childList).
    var raf = 0, schedule = function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); };
    function watch() {
      document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest(OPT_WRAP)) setTimeout(sync, 30); }, true);
      document.addEventListener('change', schedule, true);
      var moonObs = new MutationObserver(schedule);
      var watchMoon = function () {
        var mb = document.querySelector(MOON_BOX);
        if (!mb) return false;
        moonObs.observe(mb, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
        schedule(); return true;
      };
      if (!watchMoon()) {
        var finder = new MutationObserver(function () { if (watchMoon()) finder.disconnect(); });
        finder.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { finder.disconnect(); }, 15000);
      }
    }
  }

  function boot() { document.querySelectorAll('.g2pb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
